<template>
	<svg
		viewBox="0 0 24 24"
		:width="size"
		:height="size"
		fill="none"
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-hidden="true"
		focusable="false"
		v-bind="$attrs"
	>
		<path d="M4.5 4.5h15a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10l-4.5 3.5V16.5h-1a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2z" />
		<path d="M12 7.2Q12.6 9.9 15.3 10.5 12.6 11.1 12 13.8 11.4 11.1 8.7 10.5 11.4 9.9 12 7.2z" />
	</svg>
</template>

<script>
/**
 * The Syrenis brand system's `ai-assistant` glyph: a speech bubble holding a four-point spark. It
 * marks an AI helper or chat entry point, and nothing else. Do not substitute a lucide glyph for it.
 *
 * The Vue twin of syrenis-ui's `AiAssistantIcon`. Inline SVG rather than a `lucide-icon`, because
 * the brand set is not a third-party library and has no Vue package yet; when one exists, this
 * becomes a wrapper over it or goes away. Keep the path data in step with the React component.
 *
 * Brand spec: 24x24 artboard, 1.5px stroke, round cap and join, no fill, colour from `currentColor`.
 * Recolour through CSS `color`, never a `fill` prop, and keep it at 16px or larger.
 *
 * Decorative, on the brand's rule that an icon never carries meaning alone. Where it is the only
 * thing naming a control, label the control rather than the glyph.
 */
export default {
	name: 'ai-assistant-icon',
	inheritAttrs: false,
	props: {
		/** Rendered size in pixels, applied to both axes. */
		size: {
			type: Number,
			default: 20
		}
	}
}
</script>
